/** The rail and ⌘K hint on a pricing step that waits for stored pricing. */
export const PRICING_REQUIRED_HINT = `Calculate System Pricing first`
